import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  isPicked: false,
  isPickedByDoubleClickInGridRow: false,
  data: null,
};

const OM = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_OM_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_OM_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };

    case actionTypes.GET_OM_FAILURE:
      return _initState;

    case actionTypes.CHANGE_OM:
      const { data, isPickedByDoubleClickInGridRow } = action;
      return {
        ...state,
        data,
        isLoading: false,
        isPickedByDoubleClickInGridRow,
        isPicked: data.I_ZIS_OM !== null,
      };

    default:
      return state;
  }
};

export default OM;
